import { Provider } from './provider'

export class MarketplaceService extends Provider {
  /**
   * @param {string} clientId
   * @param {string|null} [clientSecret]
   * @param {Object|null} [token]
   */
  constructor(
    clientId,
    clientSecret,
    token
  ) {
    super(
      clientId,
      clientSecret,
    )

    this.sdk = require('sharetribe-flex-sdk')
    this.transactionProcessAlias = 'flex-default-process/release-1'
    this.instance = this.getNewInstance(this.sdk, token)
  }

  /**
   * @param {Object} trustedToken
   */
  getTrustedInstance(trustedToken) {
    return this.getTrustedProviderInstance(this.sdk, trustedToken)
  }

  getImageVariants() {
    return super.getProviderImageVariants(this.sdk)
  }
}
